<template>
    <div class="pro_index">
        <el-container>
            <el-aside style="width: 200px">
                <ul class="left_url_tab">
                    <li class="li-title_1">采集箱</li>
                    <li class="li-title_2 title-2-select" @click="title2Click($event,'/product/shopee/coll')">「Shopee」采集箱 ({{CBSize}})</li>
                    <li class="li-title_1">
                        待发布产品
                        <a class="a-set blueCo" href="javascript:void(0)" @click="setClassManage">设置</a>
                    </li>
                    <li class="li-title_2 tree-item">
                        <el-tree :expand-on-click-node="false" :data="treeData"  :default-expanded-keys="idArr" node-key="value" :props="defaultProps" @node-click="readyReleaseChange"></el-tree>
                    </li>
                    <li class="li-title_2" @click="title2Click($event,'/product/shopee/timeInterval')">定时发布(0)</li>
                    <li class="li-title_2" @click="releaseing">发布中 (0)</li>
                    <li class="li-title_2" @click="title2Click($event,'/product/shopee/releaseFail')">发布失败 (35)</li>
                    <li class="li-title_1">
                        在线产品
                        <a class="a-set blueCo" href="javascript:void(0)" @click="setClassManage">设置</a>
                    </li>
                    <li class="li-title_2 tree-item">
                        <!--<el-tree :data="treeData" :props="defaultProps" @node-click="onLineChange"></el-tree>-->
                        <el-tree :expand-on-click-node="false" :data="treeData"  :default-expanded-keys="idArr" node-key="value" :props="defaultProps" @node-click="onLinereadyReleaseChange"></el-tree>
                    </li>
                    <li class="li-title_1">其他</li>
                    <li class="li-title_2" @click="title2Click($event,'/product/shopee/createProduct')">创建产品</li>
                </ul>
            </el-aside>
            <el-main>
                <router-view>

                </router-view>
            </el-main>
        </el-container>
        <ClassManage @closeCMDialog_z="closeCMDialog_f" :classManageDialog="classManageDialog" ></ClassManage>
    </div>
</template>

<script>
    import ClassManage from '@/components/product/ClassManage'
    import {getTree} from '@/api/tree/tree';
    import {getCollectionBoxSize} from '@/api/product/shopee/shopee';
    export default {
        name: "index",
        components:{
            ClassManage
        },
        data() {
            return {
                classManageDialog:false,//管理分类弹窗默认关闭
                defaultProps: {
                    children: 'children',
                    label: 'label',
                    value:'value',
                },
                treeData: [],
                idArr:['1'],//默认展开第一级
                CBSize:0, //采集箱数量
            }
        },
        created() {
            var that = this
            that.getMoveClassification();
            that.getCollectionBoxSize();
        },
        methods: {
            title2Click(e,url){
                var _dom = document.querySelector('.li-title_2.title-2-select');
                if (_dom) {
                    _dom.classList.toggle('title-2-select');//当class为project的元素上没有这个CSS类时，它就新增这个CSS类；如果class为project的元素有了这个CSS类，它就是删除它。就是反转操作。
                }
                e.target.classList.toggle('title-2-select');
                this.$router.push(url);
            },
            setClassManage:function(){
                this.classManageDialog = true;
            },
            closeCMDialog_f:function(){
                this.classManageDialog = false;
            },
            //待发布的tree点击
            readyReleaseChange(val,node,tree){
                // this.$router.push({path:'/amazon/readyRelease'})
                this.$router.push({path:"/product/shopee/readyRelease",query:{treeId:val.value}})
            },
            //在线的tree点击
            onLinereadyReleaseChange(val,node,tree){
                // this.$router.push({path:'/amazon/readyRelease'})
                this.$router.push({path:"/product/shopee/onLine",query:{treeId:val.value}})
            },
            onLineChange(){
                this.$router.push({path:'/amazon/onLine'})
            },
            //移动分类树形数据
            getMoveClassification(){
                getTree().then((res) => {
                    this.treeData=res.data;
                })
            },
            //采集箱的商品数量
            getCollectionBoxSize(){
                getCollectionBoxSize().then(res => {
                    if(res.code == 200){
                        this.CBSize=res.data
                    }
                }).catch(err => {});
            },
            //发布中
            releaseing(){
                this.msgSuccess("尚在开发");
            }

        },
        mounted() {}
    }
</script>

<style scoped>
    @import '../../../assets/css/product.css';
    .pro_index{
        width: 100%;
    }
    .left_url_tab{
        border: 1px solid #ccc;
        border-bottom: none;
        font-size: 13px;
    }
    .left_url_tab li:not(:last-child){
        list-style: none;

    }

    .li-title_1{
        height: 32px;
        line-height: 32px;
        background-color: #c1c1c154;
        vertical-align: top;
        padding-left: 5px;
        font-weight: 600;
    }
    .li-title_2{
        height: 28px;
        line-height: 28px;
        vertical-align: top;
        padding-left: 20px;
        border-bottom: 1px solid #ccc;
    }
    .li-title_3{
        height: 28px;
        line-height: 28px;
        vertical-align: top;
        padding-left: 40px;
    }
    .li-title_2:not(.tree-item):hover{
        background-color: #4934b2;
        color: white;
        cursor: pointer;
    }
    .title-2-select{
        background-color: #4934b2;
        color: white;
        cursor: pointer;
    }
    .li-help{
        height: 28px;
        line-height: 28px;
        vertical-align: top;
        text-align: center;
        font-size: 16px;
    }
    .li-help a{
        text-decoration: none;
        color: #4934b2;
    }
    .tree-item{
        height: auto !important;
        padding: initial;
    }
    .tree-item .el-tree{background: initial !important;}
    .tree-item .el-tree:hover{background: initial !important;}

</style>
